import { render, staticRenderFns } from "./viewQuestionnaire.vue?vue&type=template&id=c4d1c716&scoped=true"
import script from "./viewQuestionnaire.vue?vue&type=script&lang=js"
export * from "./viewQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./viewQuestionnaire.vue?vue&type=style&index=0&id=c4d1c716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d1c716",
  null
  
)

export default component.exports